export function HasMark(type, value) {
  return value.activeMarks.some(mark => mark.type === type);
}
